// extracted by mini-css-extract-plugin
module.exports = {"horizontalDivisor":"src-components-HorizontalDivisorComponent-index-module__horizontalDivisor--3OEKa"};